import { Component, Input } from '@angular/core';

import { MomoVacationsCriteria } from '@app/activo2/manage-vacations/manage-vacations.model';

@Component({
  selector: 'app-momo-criteria-step',
  templateUrl: './criteria-step.component.html',
  styleUrls: ['./criteria-step.component.scss']
})
export class CriteriaStepComponent {
  @Input() criteria!: MomoVacationsCriteria;
  @Input() insideModal!: boolean;
}
